import React, { useState } from "react";
import { Loader2, CheckCircle2, Send } from "lucide-react";
import { api } from "@/lib/api";

export default function NewsletterForm({ source = "blog", variant = "default" }) {
    const [email, setEmail] = useState("");
    const [state, setState] = useState("idle"); // idle | submitting | done | error
    const [errorMsg, setErrorMsg] = useState("");

    async function submit(e) {
        e.preventDefault();
        if (!email.trim() || state === "submitting") return;
        setState("submitting");
        setErrorMsg("");
        try {
            await api.post("/newsletter/subscribe", { email: email.trim().toLowerCase(), source });
            setState("done");
        } catch (err) {
            setErrorMsg(err?.response?.data?.detail || "Une erreur est survenue");
            setState("error");
        }
    }

    if (state === "done") {
        return (
            <div className={variant === "compact"
                ? "rounded-xl p-4 bg-emerald-500/10 border border-emerald-500/30 flex items-center gap-2 text-sm text-emerald-200"
                : "rounded-2xl p-6 bg-emerald-500/10 border border-emerald-500/30 flex items-center gap-3"
            } data-testid="newsletter-success">
                <CheckCircle2 size={variant === "compact" ? 16 : 22} className="text-emerald-300 shrink-0" />
                <div>
                    <div className={variant === "compact" ? "text-sm font-semibold text-emerald-200" : "font-display font-bold text-white"}>
                        Inscription confirmée
                    </div>
                    {variant !== "compact" && (
                        <p className="text-xs text-zinc-400 mt-1">
                            Un article utile chaque semaine. Zéro spam, unsubscribe en 1 clic.
                        </p>
                    )}
                </div>
            </div>
        );
    }

    return (
        <div
            className={variant === "compact"
                ? "rounded-xl p-4 bg-brand-surface border border-white/10"
                : "rounded-2xl p-6 bg-gradient-to-br from-brand-indigo/20 to-brand-cyan/10 border border-brand-indigo/30"
            }
            data-testid="newsletter-form-container"
        >
            {variant !== "compact" && (
                <>
                    <div className="text-xs uppercase tracking-widest font-bold text-brand-cyan mb-2">Newsletter BOXEB2B</div>
                    <div className="font-display font-bold text-xl tracking-tight text-white">
                        1 article utile, chaque semaine.
                    </div>
                    <p className="mt-2 text-sm text-zinc-300 leading-relaxed">
                        Techniques de prospection B2B, alternatives aux gros outils, chiffres réels de campagnes.
                        Écrit par des opérationnels, jamais par des marketeurs.
                    </p>
                </>
            )}
            <form onSubmit={submit} className={variant === "compact" ? "flex gap-2" : "mt-4 flex gap-2"}>
                <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="ton@email.com"
                    disabled={state === "submitting"}
                    data-testid="newsletter-input"
                    className="flex-1 px-4 py-2.5 rounded-full bg-brand-void border border-white/10 text-sm text-white placeholder:text-zinc-600 outline-none focus:border-brand-cyan disabled:opacity-60"
                />
                <button
                    type="submit"
                    disabled={state === "submitting" || !email.trim()}
                    data-testid="newsletter-submit"
                    className="btn-cta text-white font-semibold text-sm px-5 py-2.5 rounded-full inline-flex items-center gap-2 disabled:opacity-60"
                >
                    {state === "submitting" ? <Loader2 size={14} className="animate-spin" /> : <Send size={14} />}
                    S'inscrire
                </button>
            </form>
            {state === "error" && (
                <div className="mt-2 text-xs text-rose-300" data-testid="newsletter-error">{errorMsg}</div>
            )}
            {variant !== "compact" && (
                <p className="mt-3 text-[11px] text-zinc-500 font-mono">
                    RGPD-clean · Aucune revente · Désinscription en 1 clic
                </p>
            )}
        </div>
    );
}
